// NEW SEARCH FIELD
document.addEventListener('DOMContentLoaded', function() {
    const searchToggleBtn = document.getElementById('search-toggle-btn');
    const searchOverlay = document.getElementById('search-overlay');
    const closeSearchBtn = document.getElementById('close-search-btn');
  
    if (searchToggleBtn && searchOverlay && closeSearchBtn) {
      searchToggleBtn.addEventListener('click', function(event) {
        event.preventDefault();
        searchOverlay.style.display = 'block';
      });
  
      closeSearchBtn.addEventListener('click', function() {
        searchOverlay.style.display = 'none';
      });
  
      // Close the search overlay when clicking outside the search container
      searchOverlay.addEventListener('click', function(event) {
        if (event.target === searchOverlay) {
          searchOverlay.style.display = 'none';
        }
      });
    }
  });